import { createSelector, createStructuredSelector } from 'reselect';

import { getUser, getAmplitudeInstance } from '../../modules/session/getters';

const getOwnerId = (state) =>  state.organizationSelect.ownerId;
const getOrganizationCurrencies = (state) =>  state.organizationSelect.currencies;
const getOrganizationImage = (state) =>  state.organizationSelect.imageUrl;
const getOrganizationFirstName = (state) =>  state.organizationSelect.firstName;
const getOrganizationLastName = (state) =>  state.organizationSelect.lastName;

export const getHostId = createSelector(
  [getUser, getOwnerId],
  (user, hostId) => {
    if (hostId !== '') {
      return hostId;
    }
    else if (user) {
      return user.id;
    }
    return null;
  }
);

export const getHostCurrencies = createSelector(
  [getUser, getOwnerId, getOrganizationCurrencies],
  (user, ownerId, orgCurrencies) => {
    if (user && user.currencies.length > 0 && (ownerId === user.id || ownerId === '')) {
      return user.currencies;
    }
    else if (ownerId !== '' && orgCurrencies && orgCurrencies.length > 0) {
      return orgCurrencies;
    }
    return [];
  }
);

const getHostImage = createSelector(
  [getUser, getOwnerId, getOrganizationImage],
  (user, ownerId, orgImage) => {
    if (user && (ownerId === user.id || ownerId === '')) {
      return user.image_url_50;
    }
    else if (ownerId !== '' && orgImage) {
      return orgImage;
    }
    return null;
  }
);

const getHostFirstName = createSelector(
  [getUser, getOwnerId, getOrganizationFirstName],
  (user, ownerId, orgFirstName) => {
    if (user && (ownerId === user.id || ownerId === '')) {
      return user.first_name;
    }
    else if (ownerId !== '' && orgFirstName) {
      return orgFirstName;
    }
    return null;
  }
);

const getHostLastName = createSelector(
  [getUser, getOwnerId, getOrganizationLastName],
  (user, ownerId, orgLastName) => {
    if (user && (ownerId === user.id || ownerId === '')) {
      return user.last_name;
    }
    else if (ownerId !== '' && orgLastName) {
      return orgLastName;
    }
    return null;
  }
);

export default createStructuredSelector({
  user: getUser,
  amplitudeInstance: getAmplitudeInstance,
  currencies: getHostCurrencies,
  hostId: getHostId,
  hostFirstName: getHostFirstName,
  hostLastName: getHostLastName,
  hostImage: getHostImage
});



// WEBPACK FOOTER //
// ./src/modules/organization-select/getters.js